import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "experience" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  "data-aos": "slide-up",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("ins", null, "Experience")
], -1)
const _hoisted_3 = { class: "timeline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimelineStep = _resolveComponent("TimelineStep")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationArray, (edu, index) => {
        return (_openBlock(), _createBlock(_component_TimelineStep, {
          content: edu.degree,
          "extra-details": edu.place,
          key: index,
          name: edu.institute,
          year: edu.year
        }, null, 8, ["content", "extra-details", "name", "year"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experienceArray, (workplace, index) => {
        return (_openBlock(), _createBlock(_component_TimelineStep, {
          content: workplace.details,
          "extra-details": workplace.profile,
          key: index,
          name: workplace.companyName,
          year: workplace.fromYear
        }, null, 8, ["content", "extra-details", "name", "year"]))
      }), 128))
    ])
  ]))
}